<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.75 2C4.16421 2 4.5 2.33579 4.5 2.75V7H11.5V2.75C11.5 2.33579 11.8358 2 12.25 2C12.6642 2 13 2.33579 13 2.75V13.25C13 13.6642 12.6642 14 12.25 14C11.8358 14 11.5 13.6642 11.5 13.25V8.5H4.5V13.25C4.5 13.6642 4.16421 14 3.75 14C3.33579 14 3 13.6642 3 13.25V2.75C3 2.33579 3.33579 2 3.75 2Z"
    fill="currentColor"
  />
</svg>
